// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attendance-calendar-grid button span small {
  display: block;
  max-width: 78px;
  margin-top: 4px;
  overflow: hidden;
  font-size: 8px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.attendance-calendar-grid button.holiday {
  border-color: #f9a8d4;
  background: #fdf2f8;
  color: #be185d;
  opacity: 1;
}
.attendance-calendar-grid button.leave {
  border-color: #93c5fd;
  background: #eff6ff;
  color: #1d4ed8;
  opacity: 1;
}
.attendance-calendar-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
}
.attendance-calendar-legend span {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #64748b;
  font-size: 11px;
}
.attendance-calendar-legend span::before {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  background: #dcfce7;
  content: "";
}
.attendance-calendar-legend span.leave::before { background: #bfdbfe; }
.attendance-calendar-legend span.holiday::before { background: #fbcfe8; }
`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/attendanceCalendarEvents.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;AACA,iDAAiD,mBAAmB,EAAE;AACtE,mDAAmD,mBAAmB,EAAE","sourcesContent":[".attendance-calendar-grid button span small {\n  display: block;\n  max-width: 78px;\n  margin-top: 4px;\n  overflow: hidden;\n  font-size: 8px;\n  font-weight: 800;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.attendance-calendar-grid button.holiday {\n  border-color: #f9a8d4;\n  background: #fdf2f8;\n  color: #be185d;\n  opacity: 1;\n}\n.attendance-calendar-grid button.leave {\n  border-color: #93c5fd;\n  background: #eff6ff;\n  color: #1d4ed8;\n  opacity: 1;\n}\n.attendance-calendar-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 12px;\n}\n.attendance-calendar-legend span {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: #64748b;\n  font-size: 11px;\n}\n.attendance-calendar-legend span::before {\n  width: 10px;\n  height: 10px;\n  border-radius: 3px;\n  background: #dcfce7;\n  content: \"\";\n}\n.attendance-calendar-legend span.leave::before { background: #bfdbfe; }\n.attendance-calendar-legend span.holiday::before { background: #fbcfe8; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
